import { create } from 'zustand';
import type { Notification } from '../types';

interface NotificationState {
    notifications: Notification[];
    unreadCount: number;
    notificationsLoading: boolean;
    setNotifications: (notifications: Notification[]) => void;
    prependNotification: (notification: Notification) => void;
    setUnreadCount: (count: number) => void;
    setNotificationsLoading: (loading: boolean) => void;
    markAsRead: (id: number) => void;
    markAllAsRead: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
    notifications: [],
    unreadCount: 0,
    notificationsLoading: false,
    setNotifications: (notifications) => set({ notifications }),
    prependNotification: (notification) =>
        set((state) => {
            if (state.notifications.some((n) => n.id === notification.id)) {
                return state;
            }
            return { notifications: [notification, ...state.notifications] };
        }),
    setUnreadCount: (unreadCount) => set({ unreadCount }),
    setNotificationsLoading: (notificationsLoading) => set({ notificationsLoading }),
    markAsRead: (id) =>
        set((state) => ({
            notifications: state.notifications.map((n) =>
                n.id === id ? { ...n, is_read: true } : n
            ),
            unreadCount: Math.max(0, state.unreadCount - 1),
        })),
    markAllAsRead: () =>
        set((state) => ({
            notifications: state.notifications.map((n) => ({ ...n, is_read: true })),
            unreadCount: 0,
        })),
}));
